jQuery( document ).ready( function( $ ) {

} );